<template>

    <div class="group">

        <h2 class="heading_line _jp _alpha-down">
            <p><span>プライス</span></p>
            <div class="line"></div>
        </h2>

        <div class="form_select-wrap _range">

            <div class="form_select">
                <select name="particular-price" id="particular-price-lower-limit" v-model="price_min" v-on:change="selectPriceMin" >
                    <option v-for="price_min in price_mins" 
                        v-bind:value="price_min.value" 
                        v-bind:key="price_min.id">
                        {{ price_min.name }}円以上
                    </option>
                </select>
            </div>

            <div class="form_select">
                <select name="particular-price" id="particular-price-upper-limit" v-model="price_max" v-on:change="selectPriceMax">
                    <option v-for="price_max in price_maxs" 
                        v-bind:value="price_max.value" 
                        v-bind:key="price_max.id">
                        {{ price_max.name }}円以下
                    </option>
                </select>
            </div>

        </div>

    </div><!--/プライス-->

</template>

<script>
    export default {
        data() {
            return {
                price_min: '',
                price_max: '',
                prices: [
                    { name: '1,000', value: 1000},
                    { name: '5,000', value: 5000},
                    { name: '10,000', value: 10000},
                    { name: '50,000', value: 50000},
                    { name: '100,000', value: 100000},
                    { name: '500,000', value: 500000},
                    { name: '1,000,000', value: 1000000},
                ],
                price_mins: [],
                price_maxs: [],
            }
        },
        created() {
            this.price_maxs = this.prices;
            this.price_mins = this.prices;
        },
        methods: {
            selectPriceMin() {
                var items = [];
                var price_min = this.price_min;
                this.price_maxs = this.prices;

                this.price_maxs.forEach(function(item, index){
                    if (item.value > price_min) {
                        items.push(item)
                    }
                });

                this.price_maxs = items;
                this.$store.state.search.form.price_min = this.price_min;
            },
            selectPriceMax() {
                var items = [];
                var price_max = this.price_max;
                this.price_mins = this.prices;

                this.price_mins.forEach(function(item, index){
                    if (item.value < price_max) {
                        items.push(item)
                    }
                });

                this.price_mins = items;
                this.$store.state.search.form.price_max = this.price_max;
            }
        }
    }
</script>
